// extracted by mini-css-extract-plugin
export default {"AppMenuList":"Navigation_AppMenuList__huVqJ","AppMenuList__right":"Navigation_AppMenuList__right__8oAQd","AppMenuList--vertical":"Navigation_AppMenuList--vertical__a93YB"};